import { gql } from '@apollo/client';

export default gql`
  query checkPromoCodeRedemptionByDisplayValue($input: CheckPromoCodeRedemptionByDisplayValueInput!) {
    checkPromoCodeRedemptionByDisplayValue(input: $input) {
      hasBeenRedeemed
    }
  }
`;
